import { render, staticRenderFns } from "./user_group_management.vue?vue&type=template&id=7cb670ac&scoped=true&"
import script from "./user_group_management.vue?vue&type=script&lang=js&"
export * from "./user_group_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb670ac",
  null
  
)

export default component.exports